import React from "react";
import _flatten from "lodash/flatten";
import _compact from "lodash/compact";
import { Route, Routes } from "react-router-dom";
import { SuperAdminLayout } from ".";
import SuperAdminRouteMaster from "./routeMaster";
import FourNotFour from "../FourNotFour";
import ExternalApp from "../CustomerAdmin/ExternalApp";

const SuperAdminRouter = (props) => {
  const AppRoute = props.AppRoute;
  let newRoute = [...SuperAdminRouteMaster];
  SuperAdminRouteMaster.forEach((route, idx) => {
    if (props.currentUser.type === "SU" && route.path === "/secureId")
      newRoute.splice(idx, 1);
    if (props.currentUser.type !== "SA" && route.path === "/simulator")
      newRoute.splice(idx, 1);
    /** Only show huddle nurse app to EM user type **/
    if (props.currentUser.type === "EM" && route.path !== "/mtds")
      newRoute.splice(idx, 1);
    if (props.currentUser.type === "FO" && route.path !== "/inventory")
      newRoute.splice(idx, 1);
  });

  return (
    <Routes>
      {newRoute.map((route, idx) => {
        if (!route.component) return null;
        return (
          <Route
            key={idx}
            path={route.path}
            element={
              <AppRoute
                layout={SuperAdminLayout}
                component={route.component}
                pathkey={route.key}
                routeObj={route}
              />
            }
          />
        );
      })}
      {_flatten(_compact(newRoute.map((x) => x.collapse))).map((route, idx) => {
        if (!route.component) return null;
        return (
          <Route
            key={`sub-${idx}`}
            path={route.path}
            element={
              <AppRoute
                layout={SuperAdminLayout}
                component={route.component}
                pathkey={route.key}
                routeObj={route}
              />
            }
          />
        );
      })}

      {renderCustomAppsRoutes(props)}

      <Route path="*" element={<FourNotFour />} />
    </Routes>
  );
};

// ponytail: dynamic require → import.meta.glob (Vite native, eager bundle)
const appRoutesGlob = import.meta.glob(
  "../CustomerAdmin/Apps/*/routes.{jsx,js}",
  { eager: true }
);

const renderCustomAppsRoutes = (props) => {
  const AppRoute = props.AppRoute;
  const routes = [];
  (
    [
      ...(props.currentUser.apps || []),
      { app_slug: "microwave-heatmap", is_installed: true },
    ] || []
  )
    .filter((x) => x.is_installed)
    .forEach((app) => {
      if (app.app_type === "External") {
        routes.push(
          <Route
            key={`${app.app_slug}-ext`}
            path={`/${app.app_slug}/*`}
            element={
              <AppRoute
                layout={SuperAdminLayout}
                component={ExternalApp}
                routeObj={app || {}}
                src={app.external_url}
              />
            }
          />
        );
        return;
      }
      let extraRoutes = [];
      const key = Object.keys(appRoutesGlob).find((k) =>
        k.includes(`/${app.app_slug}/routes.`)
      );
      if (key) extraRoutes = appRoutesGlob[key].default || [];

      extraRoutes.forEach((er, index) => {
        routes.push(
          <Route
            key={`${app.app_slug}-${index}`}
            path={`/${app.app_slug}${er.path === "/" ? "" : er.path}`.replace(/\/$/, "") || "/"}
            element={
              <AppRoute
                layout={SuperAdminLayout}
                component={er.component}
                routeObj={app || {}}
              />
            }
          />
        );
      });
    });
  return routes;
};

export default SuperAdminRouter;
